var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "layout" },
    [
      _c("div", { staticClass: "layout__header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c("div", { staticClass: "layout__controls" }, [
          _c("div", { staticClass: "form-inline" }, [
            _c(
              "button",
              {
                staticClass: "btn-success btn--text",
                attrs: { type: "button" },
                on: { click: _vm.enviar }
              },
              [
                _c("i", { staticClass: "fa fa-share" }),
                _c("span", [_vm._v("Enviar")])
              ]
            )
          ])
        ])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "table-responsive" }, [
        _c("table", [
          _vm._m(1),
          _vm._v(" "),
          _c(
            "tbody",
            [
              _c(
                "tr",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.form.detalles.length === 0,
                      expression: "form.detalles.length === 0"
                    }
                  ]
                },
                [_vm._m(2)]
              ),
              _vm._v(" "),
              _vm.form.detalles.length !== 0
                ? _c("tr", [
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td"),
                    _vm._v(" "),
                    _c("td", [
                      _c("label", { attrs: { for: "enviar_edi_todos" } }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.form.enviar_todos,
                              expression: "form.enviar_todos"
                            }
                          ],
                          attrs: { id: "enviar_edi_todos", type: "checkbox" },
                          domProps: {
                            checked: Array.isArray(_vm.form.enviar_todos)
                              ? _vm._i(_vm.form.enviar_todos, null) > -1
                              : _vm.form.enviar_todos
                          },
                          on: {
                            change: [
                              function($event) {
                                var $$a = _vm.form.enviar_todos,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = null,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      _vm.$set(
                                        _vm.form,
                                        "enviar_todos",
                                        $$a.concat([$$v])
                                      )
                                  } else {
                                    $$i > -1 &&
                                      _vm.$set(
                                        _vm.form,
                                        "enviar_todos",
                                        $$a
                                          .slice(0, $$i)
                                          .concat($$a.slice($$i + 1))
                                      )
                                  }
                                } else {
                                  _vm.$set(_vm.form, "enviar_todos", $$c)
                                }
                              },
                              _vm.changeTodos
                            ]
                          }
                        }),
                        _vm._v(" "),
                        _c("span")
                      ])
                    ]),
                    _vm._v(" "),
                    _c("td")
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm._l(_vm.form.detalles, function(detalle, index) {
                return _c("tr", { key: detalle.id }, [
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.localizacion_id_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.tpi_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.dimension_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.dimension2_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(parseFloat(detalle.pieza_edi)) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.codigo_rep_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.repair_method_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.descripcion_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.tipo_material_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.labour_rate_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.handling_total_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.tax_total_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.horas_hombre_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.precio_edi) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.damage_code) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _vm._v(
                      "\n            " +
                        _vm._s(detalle.tipo_unidad) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c("label", { attrs: { for: "enviar_edi" + detalle.id } }, [
                      _c("input", {
                        directives: [
                          {
                            name: "model",
                            rawName: "v-model",
                            value: detalle.bool_enviar_edi,
                            expression: "detalle.bool_enviar_edi"
                          }
                        ],
                        attrs: {
                          type: "checkbox",
                          id: "enviar_edi" + detalle.id
                        },
                        domProps: {
                          checked: Array.isArray(detalle.bool_enviar_edi)
                            ? _vm._i(detalle.bool_enviar_edi, null) > -1
                            : detalle.bool_enviar_edi
                        },
                        on: {
                          change: [
                            function($event) {
                              var $$a = detalle.bool_enviar_edi,
                                $$el = $event.target,
                                $$c = $$el.checked ? true : false
                              if (Array.isArray($$a)) {
                                var $$v = null,
                                  $$i = _vm._i($$a, $$v)
                                if ($$el.checked) {
                                  $$i < 0 &&
                                    _vm.$set(
                                      detalle,
                                      "bool_enviar_edi",
                                      $$a.concat([$$v])
                                    )
                                } else {
                                  $$i > -1 &&
                                    _vm.$set(
                                      detalle,
                                      "bool_enviar_edi",
                                      $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1))
                                    )
                                }
                              } else {
                                _vm.$set(detalle, "bool_enviar_edi", $$c)
                              }
                            },
                            _vm.changeIndividual
                          ]
                        }
                      }),
                      _c("span")
                    ])
                  ]),
                  _vm._v(" "),
                  _c("td", [
                    _c(
                      "button",
                      {
                        staticClass: "btn--text btn-info",
                        attrs: { type: "button" },
                        on: {
                          click: function($event) {
                            return _vm.editar(index)
                          }
                        }
                      },
                      [_c("i", { staticClass: "fa fa-edit" })]
                    )
                  ])
                ])
              })
            ],
            2
          )
        ]),
        _vm._v(" "),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.form.detalles.length !== 0,
                expression: "form.detalles.length !== 0"
              }
            ],
            staticClass: "col-md-12 form-inline"
          },
          [
            _c("div", [
              _c("p", [_vm._v("Horas hombre: " + _vm._s(_vm.horas_hombre))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [_vm._v("Costo material: " + _vm._s(_vm.precio))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [_vm._v("Total labor: " + _vm._s(_vm.total_labor))])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _vm._v("Total caja: " + _vm._s(_vm.form.propiedades.amount_b))
              ])
            ]),
            _vm._v(" "),
            _c("div", [
              _c("p", [
                _vm._v(
                  "Total máquina: " + _vm._s(_vm.form.propiedades.amount_m)
                )
              ])
            ])
          ]
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "modal-buttons" }, [
        _c(
          "button",
          { staticClass: "btn-success", on: { click: _vm.guardar } },
          [
            _c("i", { staticClass: "fa fa-save" }),
            _c("span", [_vm._v("Guardar")])
          ]
        ),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "btn-danger btn--text",
            on: {
              click: function($event) {
                return _vm.$emit("cerrar")
              }
            }
          },
          [
            _c("i", { staticClass: "fa fa-times" }),
            _c("span", [_vm._v("Cerrar")])
          ]
        )
      ]),
      _vm._v(" "),
      _c(
        "modal",
        {
          attrs: {
            clickToClose: false,
            name: "detalle",
            height: "auto",
            width: "80%",
            adaptive: "",
            resizable: "",
            reset: "",
            scrollable: ""
          }
        },
        [
          _c("detalle", {
            on: {
              input: _vm.inputDetalle,
              cerrar: function($event) {
                return _vm.$modal.hide("detalle")
              }
            },
            model: {
              value: _vm.selectedDetalle,
              callback: function($$v) {
                _vm.selectedDetalle = $$v
              },
              expression: "selectedDetalle"
            }
          })
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "layout__title" }, [
      _c("h3", [_vm._v("Detalles del Contenedor")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("thead", [
      _c("tr", [
        _c("th", [_vm._v("Localización")]),
        _vm._v(" "),
        _c("th", [_vm._v("TPI")]),
        _vm._v(" "),
        _c("th", [_vm._v("Alto")]),
        _vm._v(" "),
        _c("th", [_vm._v("Ancho")]),
        _vm._v(" "),
        _c("th", [_vm._v("Cantidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Componente")]),
        _vm._v(" "),
        _c("th", [_vm._v("Método de reparación")]),
        _vm._v(" "),
        _c("th", [_vm._v("Descripción")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo de material")]),
        _vm._v(" "),
        _c("th", [_vm._v("Lb. Rate")]),
        _vm._v(" "),
        _c("th", [_vm._v("Handling total")]),
        _vm._v(" "),
        _c("th", [_vm._v("Total Tax")]),
        _vm._v(" "),
        _c("th", [_vm._v("Horas hombre")]),
        _vm._v(" "),
        _c("th", [_vm._v("Precio")]),
        _vm._v(" "),
        _c("th", [_vm._v("Damage")]),
        _vm._v(" "),
        _c("th", [_vm._v("Tipo unidad")]),
        _vm._v(" "),
        _c("th", [_vm._v("Enviar en EDI")]),
        _vm._v(" "),
        _c("th")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("td", { attrs: { colspan: "13" } }, [
      _c("strong", [_vm._v("No se ha agregado detalles.")])
    ])
  }
]
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3ac605db", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3ac605db","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/forms/sistema/EditarDetalles.vue
// module id = 343
// module chunks = 0